// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-a69fbcb1] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.notecard[data-v-a69fbcb1] {
  color: var(--color-main-text) !important;
  background-color: var(--note-background) !important;
  border-inline-start: 4px solid var(--note-theme);
  border-radius: var(--border-radius);
  margin: 1rem 0;
  margin-top: 1rem;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.notecard__icon--heading[data-v-a69fbcb1] {
  margin-bottom: auto;
  margin-top: 0.3rem;
}
.notecard--success[data-v-a69fbcb1] {
  --note-background: rgba(var(--color-success-rgb), 0.1);
  --note-theme: var(--color-success);
}
.notecard--info[data-v-a69fbcb1] {
  --note-background: rgba(var(--color-info-rgb), 0.1);
  --note-theme: var(--color-info);
}
.notecard--error[data-v-a69fbcb1] {
  --note-background: rgba(var(--color-error-rgb), 0.1);
  --note-theme: var(--color-error);
}
.notecard--warning[data-v-a69fbcb1] {
  --note-background: rgba(var(--color-warning-rgb), 0.1);
  --note-theme: var(--color-warning);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcNoteCard-BLPU1den.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,mDAAmD;EACnD,gDAAgD;EAChD,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sDAAsD;EACtD,kCAAkC;AACpC;AACA;EACE,mDAAmD;EACnD,+BAA+B;AACjC;AACA;EACE,oDAAoD;EACpD,gCAAgC;AAClC;AACA;EACE,sDAAsD;EACtD,kCAAkC;AACpC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-a69fbcb1] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.notecard[data-v-a69fbcb1] {\n  color: var(--color-main-text) !important;\n  background-color: var(--note-background) !important;\n  border-inline-start: 4px solid var(--note-theme);\n  border-radius: var(--border-radius);\n  margin: 1rem 0;\n  margin-top: 1rem;\n  padding: 1rem;\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n.notecard__icon--heading[data-v-a69fbcb1] {\n  margin-bottom: auto;\n  margin-top: 0.3rem;\n}\n.notecard--success[data-v-a69fbcb1] {\n  --note-background: rgba(var(--color-success-rgb), 0.1);\n  --note-theme: var(--color-success);\n}\n.notecard--info[data-v-a69fbcb1] {\n  --note-background: rgba(var(--color-info-rgb), 0.1);\n  --note-theme: var(--color-info);\n}\n.notecard--error[data-v-a69fbcb1] {\n  --note-background: rgba(var(--color-error-rgb), 0.1);\n  --note-theme: var(--color-error);\n}\n.notecard--warning[data-v-a69fbcb1] {\n  --note-background: rgba(var(--color-warning-rgb), 0.1);\n  --note-theme: var(--color-warning);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
